export enum IdTypes {
  SSN = 'SSN',
  Passport = 'Passport',
  Other = 'Other government issued ID',
}
